<template>
  <div class="ComeInAndGoOut"
       v-loading.fullscreen.lock="fullscreenLoading">
    <!-- =================弹出层start===================== -->
    <el-dialog title="添加认领单"
               class="addClaimOrder"
               @open='start_scan=false'
               :visible.sync="rl_dialog"
               width="65%">
      <el-form :model="claimData"
               label-width="80px">
        <el-form-item label="快递单号:"
                      label-width="100px">
          <el-input class="claimData_input"
                    v-model="claimData.claim_number"></el-input>
        </el-form-item>
        <el-form-item label="快递公司:"
                      label-width="100px">
          <el-select v-model="rk_data.kdname"
                     placeholder="请选择快递公司"
                     filterable>
            <el-option v-for="item in allKD100"
                       :key="item.code"
                       :label="item.name"
                       :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="装箱单/物品:"
                      label-width="150px">
          <div class="zxdInfo">
            <el-button @click="addZXD()">
              添加箱
            </el-button>
            <el-table :data="rk_data.zxd"
                      style="width: 100%; "
                      stripe>
              <el-table-column label="箱号"
                               width="50"
                               type="index">

              </el-table-column>
              <el-table-column label="长度"
                               width="110"
                               height='50'>
                <template slot-scope="scope">
                  <el-input v-model="scope.row.chang"
                            placeholder="CM"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="宽度"
                               width="110"
                               height='50'>
                <template slot-scope="scope">
                  <el-input v-model="scope.row.kuan"
                            placeholder="CM"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="高度"
                               width="110"
                               height='50'>
                <template slot-scope="scope">
                  <el-input v-model="scope.row.gao"
                            placeholder="CM"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="重量"
                               width="110"
                               height='50'>
                <template slot-scope="scope">
                  <el-input v-model="scope.row.weight"
                            placeholder="KG"></el-input>
                </template>
              </el-table-column>

              <el-table-column label="子单号"
                               height='50'>
                <template slot-scope="scope">
                  <el-input v-model="scope.row.zdnum"
                            placeholder="(可选)请输入子单号">
                  </el-input>
                </template>
              </el-table-column>
              <el-table-column label="操作"
                               height='50'>
                <template slot-scope="scope">
                  <el-button @click="removeZXD(scope.$index)"
                             type="danger"><i class="el-icon-delete"></i></el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>

        </el-form-item>

      </el-form>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="rl_dialog = false">取 消</el-button>
        <el-button type="primary"
                   @click="claim_order_full()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="请添加附加费"
               :visible.sync="additionalShow"
               width="500px">
      <el-form>
        <el-form-item label="物流单号:"
                      v-if="isID"
                      label-position='top'>
          <el-input v-model="additionalWlnum"
                    placeholder='请输入物流单号'></el-input>
        </el-form-item>
        <el-form-item label="附加费信息:"
                      label-position='top'>
          <div class="item_view">
            <div class="view_list">
              <span>名称:</span>
              <el-select v-model="additionalInfo"
                         placeholder="显示出的名称">
                <el-option label="超长附加费"
                           value="超长附加费">
                </el-option>
                <el-option label="超重附加费"
                           value="超重附加费">
                </el-option>
              </el-select>

            </div>
            <div class="view_list">
              <span>金额:</span>
              <el-input v-model.number="additionalPrice"
                        type="number"
                        placeholder='附加费金额（RMB）'></el-input>
            </div>

          </div>
        </el-form-item>
      </el-form>

      <span slot="footer"
            class="dialog-footer">
        <el-button @click="additionalShow = false">取 消</el-button>
        <el-button type="primary"
                   @click="addAdditional()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="其他操作"
               :visible.sync="otherOperation"
               width="400px">
      <div class="other_view">
        <el-button type="primary"
                   @click="showAdditional">添加附加费</el-button>
        <el-button type="primary"
                   @click="skip_print_view">打印票单</el-button>
        <el-button type="primary"
                   @click="returnPage()">继续出库</el-button>
      </div>
    </el-dialog>
    <!-- =================弹出层end===================== -->

    <div class="comeInAndGoOut_top">
      <div class="comeInAndGoOut_top_btn">
        <el-radio v-model="goOut"
                  :label='true'
                  @change='tab_eliminate_data'
                  class="be_put_storage"
                  border>入 库</el-radio>
        <el-radio v-model="goOut"
                  @change='tab_eliminate_data'
                  :label='false'
                  class="chuku_btn"
                  :class="!goOut?'delivery_carg_ostorage':'' "
                  border>出 库</el-radio>
      </div>
      <div class="manual_operation">
        <el-button @click="showAdditional_external()">补添附加费</el-button>
        <el-button @click="clickPrint()">打印票单</el-button>
        <el-button @click="skipPrin_manual()">手动打印（临时功能）</el-button>
        <el-button @click="manualOperation(goOut)">手动填写</el-button>
      </div>
    </div>

    <div class="comeInAndGoOut_mian">

      <transition name="el-zoom-in-top">
        <div class="orderNumberNull"
             v-if="!get_order_data_null&&(isData==''?true:(isData.order.type==0))">
          <div class="scan_a_QR_code_img"
               :class="!goOut?'ck_bg':''"></div>
          <div class="scan_a_QR_code_title"
               :class="!goOut?'ck_bg':''">
            请先使用扫码枪扫码
          </div>

        </div>
      </transition>

      <!-- 未找单号 -->
      <transition name="el-zoom-in-top">
        <div class="orderNumberNull"
             v-if="get_order_data_null&&goOut">
          <div class="orderNumberNull_img"></div>
          <div class="orderNumberNull_title">
            没有找到 {{kdnum}} 快递号的订单,您可以选择以下处理
          </div>
          <div class="orderNumberNull_operation">
            <el-button type="primary"
                       @click="in_add_claim()"
                       class="add_claim">添加认领单</el-button>
            <el-button type="primary"
                       @click="manualOperation()"
                       class="add_min_order">添加主单号</el-button>
          </div>
        </div>
      </transition>

      <!-- 入库 -->
      <transition name="el-zoom-in-top">
        <div class='be_put_storage_main'
             v-if="isData!=''&&goOut&&(isData.order.type==1||isData.order.type==2)">
          <div class="be_put_storage_top">
            <span>填写入库信息
              <span class="orderType">
                ({{isData.order.type==1?'商业件':'集运'}})
              </span>
            </span>
          </div>
          <div class="be_put_storage_content">
            <el-form ref="form"
                     :model="rk_data"
                     label-width="200px">
              <el-form-item label="快递单号:">
                <span class="kdnumber">
                  <el-tag>
                    {{kdnum}}
                  </el-tag>
                </span>
              </el-form-item>
              <el-form-item label="下单用户:">
                <span class="kdnumber">
                  <el-tag>
                    {{isData.order.jjname}}
                  </el-tag>
                </span>
              </el-form-item>
              <el-form-item label="包裹数量:">
                <span class="kdnumber">
                  <el-tag>
                    {{isData.order.bgnum}}
                  </el-tag>
                </span>
              </el-form-item>

              <el-form-item label="请选择快递公司:"
                            v-if=" isData.order.type==1">
                <el-select v-model="rk_data.kdname"
                           placeholder="(可选)请选择快递公司"
                           filterable>
                  <el-option v-for="item in allKD100"
                             :key="item.code"
                             :label="item.name"
                             :value="item.code">
                  </el-option>
                </el-select>

              </el-form-item>
              <el-form-item label="装箱单:"
                            v-if=" isData.order.type==2">
                <el-table :data="rk_data.zxd"
                          style="width: 100%"
                          stripe>
                  <el-table-column label="箱号"
                                   width="100"
                                   type="index">
                  </el-table-column>
                  <el-table-column label="长度"
                                   width="110"
                                   height='50'>
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.chang"
                                placeholder="CM"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="宽度"
                                   width="110"
                                   height='50'>
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.kuan"
                                placeholder="CM"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="高度"
                                   width="110"
                                   height='50'>
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.gao"
                                placeholder="CM"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="重量"
                                   width="110"
                                   height='50'>
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.weight"
                                placeholder="KG"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="子单号"
                                   height='50'>
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.zdnum"
                                placeholder="请输入子单号">
                      </el-input>
                    </template>
                  </el-table-column>
                </el-table>
              </el-form-item>

              <el-form-item label="装箱单/物品:"
                            v-if=" isData.order.type==1">
                <div class="zxdInfo">
                  <el-button @click="addZXD()">
                    添加箱
                  </el-button>
                  <el-table :data="rk_data.zxd"
                            style="width: 100%; "
                            stripe>
                    <!-- TY112630425 -->
                    <!-- box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1) -->
                    <el-table-column type="expand">
                      <template slot-scope="props">
                        <div class="expand_btn">
                          <el-button size="mini"
                                     @click="addGoodS(props.$index)"
                                     type="success">
                            添加物品
                          </el-button>
                        </div>
                        <el-table :data="props.row.wpinfo"
                                  style="width: 100%;box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1) ">
                          <el-table-column label="物品中文名"
                                           :key="props.row.name"
                                           width="120">
                            <template slot-scope="scope">
                              <el-input v-model='scope.row.name'
                                        placeholder="中文"></el-input>
                            </template>
                          </el-table-column>

                          <el-table-column label="英文名"
                                           width="100">
                            <template slot-scope="scope">
                              <el-input v-model='scope.row.enname'
                                        placeholder='English'></el-input>
                            </template>
                          </el-table-column>

                          <el-table-column label="物品类型"
                                           width="110">
                            <template slot-scope="scope">
                              <el-select v-model="scope.row.wptype"
                                         placeholder="点击选择"
                                         filterable>
                                <el-option v-for="item in goodsInfo"
                                           :key="item.id"
                                           :label="item.name"
                                           :value="item.id">
                                  <span style="widht:100%;display:flex">{{ item.name}}</span>
                                </el-option>
                              </el-select>
                            </template>
                          </el-table-column>

                          <el-table-column label="物品数量"
                                           width="100">
                            <template slot-scope="scope">
                              <el-input v-model.number='scope.row.num'
                                        placeholder="数量"></el-input>
                            </template>
                          </el-table-column>

                          <el-table-column label="数量单位"
                                           width="120"
                                           type="index">
                            <template slot-scope="scope">
                              <el-select v-model="scope.row.unit"
                                         placeholder="请选择">
                                <el-option v-for="(item,index) in unitData"
                                           :key="index"
                                           :label="item"
                                           :value="item">
                                </el-option>
                              </el-select>
                            </template>
                          </el-table-column>

                          <el-table-column prop="unitprice"
                                           label="物品单价"
                                           width="100">
                            <template slot-scope="scope">
                              <el-input v-model.number='scope.row.unitprice'
                                        placeholder="单价"></el-input>
                            </template>
                          </el-table-column>

                          <el-table-column prop="unitprice"
                                           label="物品总价">
                            <template slot-scope="scope">
                              <span style='color:#409eff'>
                                {{scope.row.unitprice*scope.row.num !== 0?
                  scope.row.totalamount = scope.row.unitprice*scope.row.num:
                  0}}
                              </span>
                            </template>
                          </el-table-column>

                          <el-table-column prop="unitprice"
                                           label="操作">
                            <template slot-scope="scope_1">
                              <el-button type="danger"
                                         @click="deleteGoods(props.$index,scope_1.$index)">删除</el-button>
                            </template>
                          </el-table-column>

                        </el-table>
                      </template>
                    </el-table-column>
                    <el-table-column label="箱号"
                                     width="50"
                                     type="index">

                    </el-table-column>
                    <el-table-column label="长度"
                                     width="110"
                                     height='50'>
                      <template slot-scope="scope">
                        <el-input v-model="scope.row.chang"
                                  placeholder="CM"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column label="宽度"
                                     width="110"
                                     height='50'>
                      <template slot-scope="scope">
                        <el-input v-model="scope.row.kuan"
                                  placeholder="CM"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column label="高度"
                                     width="110"
                                     height='50'>
                      <template slot-scope="scope">
                        <el-input v-model="scope.row.gao"
                                  placeholder="CM"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column label="重量"
                                     width="110"
                                     height='50'>
                      <template slot-scope="scope">
                        <el-input v-model="scope.row.weight"
                                  placeholder="KG"></el-input>
                      </template>
                    </el-table-column>

                    <el-table-column label="子单号"
                                     height='50'>
                      <template slot-scope="scope">
                        <el-input v-model="scope.row.zdnum"
                                  placeholder="(可选)请输入子单号">
                        </el-input>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作"
                                     height='50'>
                      <template slot-scope="scope">
                        <el-button @click="removeZXD(scope.$index)"
                                   type="danger"><i class="el-icon-delete"></i></el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>

              </el-form-item>

              <el-form-item label="物品说明:"
                            v-if=" isData.order.type==1">
                <el-table :data="goodsInfo"
                          style="width: 70%;padding-bottom: 70px;">
                  <el-table-column prop="name"
                                   label="物品名"
                                   width="180">
                  </el-table-column>
                  <el-table-column prop="info"
                                   label="物品说明">
                  </el-table-column>
                </el-table>
              </el-form-item>
            </el-form>
            <el-tooltip class="item"
                        effect="dark"
                        content="提交入库"
                        placement="top">
              <div class="confirm_request"
                   @click="confirm_rk">
                <i class="el-icon-check"></i>
              </div>
            </el-tooltip>

          </div>
        </div>
      </transition>

      <!-- 出库 -->
      <transition name="el-zoom-in-top">
        <div class='delivery_cargo_storage_main'
             v-if="kdnum!=''&&!goOut&&isData!=''">
          <div class="delivery_cargo_storage_top">
            <span>填写出库信息
              <span class="orderType">
                <!-- ({{isData.order.type==1?'非集运':'集运'}}) -->
              </span>
            </span>
          </div>
          <div class="delivery_cargo_storage_content">
            <el-form ref="form"
                     :model="rk_data"
                     label-width="200px">

              <el-form-item label="快递单号:">
                <span class="kdnumber">
                  <el-tag type="success">
                    {{kdnum}}
                  </el-tag>
                </span>
              </el-form-item>

              <el-form-item label="渠道:"
                            class="select_ck">
                <el-select v-model="ckDitch"
                           placeholder="请选择">
                  <el-option v-for="item in ckDitchList"
                             :key="item.id"
                             :label="item.channelname"
                             :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="选择出库司机:"
                            class="select_ck">
                <el-select v-model="ck_data.driverid"
                           placeholder="请选择">
                  <el-option v-for="item in driver"
                             :key="item.value"
                             :label="item.label.name+''+' -'+item.label.mobile"
                             :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="司机信息:"
                            v-if="ck_data.driverid===0||ck_data.driverid==='0'"
                            class="select_ck">
                <el-input v-model="ck_data.remark"
                          placeholder="请输入司机姓名+手机号码"></el-input>
              </el-form-item>

              <el-form-item label="打印票单:">
                <span class="kdnumber">
                  <el-button @click="skip_print_view()"
                             class="skipPrintBtn"
                             type="success"
                             plain>
                    进入打印
                  </el-button>
                </span>
              </el-form-item>

            </el-form>
            <el-tooltip class="item"
                        effect="dark"
                        content="提交出库"
                        placement="top">
              <div class="confirm_request request_ck"
                   @click="ck_message">
                <i class="el-icon-check"></i>
              </div>
            </el-tooltip>

          </div>
        </div>

      </transition>
    </div>
  </div>
</template>

<script>
import common from '@/assets/js/common'
import { apiAppAdditional, apiDeliveryCargoStorage, apiNewBePutInStorage, apiOrderDetails, apiDeliveryStorage } from '@/request/api'
export default {
  name: 'ComeInAndGoOut',
  data () {
    return {
      // -------------已经入库的订单ID-----------
      edOrderid: '',
      // -------------获取更多-----------
      isID: true,
      // -------------显示更多操作-----------
      otherOperation: false,
      // -------------出库渠道-----------
      ckDitch: '',
      // -------------出库渠道list-----------
      ckDitchList: [],
      // -------------推荐附加费-物流单号-----------
      additionalWlnum: '',
      // -------------推荐附加费-名称-----------
      additionalInfo: '',
      // -------------推荐附加费-金额-----------
      additionalPrice: '',
      // -------------仓库添加附加费-----------
      additionalShow: false,
      // -------------是否启用扫码出入库-----------
      start_scan: true,
      // -------------出库数据-----------
      ck_data: {
        driverid: '',
        remark: ''
      },
      // -------------司机列表-----------
      driver: '',
      //-------------认领快递数据------------------
      claimData: {
        claim_number: '',                //单号
        claim_kdname: '',                //快递公司名
        claim_zxd: [{                         //装箱单
          chang: '',
          kuan: '',
          gao: '',
          weight: '',
          tj: '',
          zdnum: '',
        }],
        claim_wpinfo: [{                     //装箱单
          name: '',
          cnname: '',
          wptype: '',
          num: '',
          unit: '',
          unitprice: '',
          totalamount: '',
        }],
      },
      //-------------是否显示弹出层-----------
      rl_dialog: false,               //添加认领单

      //-------------是否扫不到订单-----------
      get_order_data_null: false,
      //-------------单位-----------
      unitData: ['个', '台', '套', '双', '件', '只', '支', '把', '本', '片', '条'],
      //-------------货币-----------
      currenctyDate: { '人民币': 'CNY', '美元': 'USD', '越南盾': 'VND', '新加坡元': 'MOP', '日元': 'JPY', '韩元': 'KRW', '马币': 'MYR', '台币': 'NTD', '港币': 'HKD', '欧元': 'EUR', '英镑': 'GBP', '法郎': 'FRF', '印度卢比': 'INR', '俄罗斯卢布': 'RUB', '澳大利亚元': 'AUD', '荷兰盾': 'NLG' },
      //-------------物品类型-----------
      goodsInfo: [],
      //-------------加载动画-----------
      fullscreenLoading: false,
      //-------------快递100数据-----------
      allKD100: '',
      //-------------入库拖鞋数据-----------
      rk_data: {
        kdname: '',
        zxd: [],
        wpinfo: []
      },
      //-------------读取到扫码枪值-----------
      kdnum: '',
      //-------------是否具有数据-----------
      isData: '',
      //-------------判断当前为入库还是出口-----------
      goOut: true,
    }
  },
  methods: {
    // -------------删除物品-----------
    deleteGoods (index, k) {
      this.rk_data.zxd[index].wpinfo.splice(0, parseInt(k, 10) + 1)
    },
    // -------------添加物品-----------
    addGoodS (index) {
      if (!this.rk_data.zxd[index].wpinfo) {
        this.$set(this.rk_data.zxd[index], 'wpinfo', [])
      }
      this.rk_data.zxd[index].wpinfo.push({
        name: '',
        enname: '',
        wptype: '',
        num: '',
        unit: '',
        unitprice: '',
      })

    },
    // -------------删除装箱单-----------
    removeZXD (id) {
      this.rk_data.zxd.splice(id, 1)
    },
    // -------------添加装箱单-----------
    addZXD () {
      this.rk_data.zxd.push({
        chang: "",
        gao: "",
        kuan: "",
        tj: "",
        weight: "",
        zdnum: "",
        no: parseInt(this.rk_data.zxd.length, 10) + 1
      })
    },
    // -------------跳转手动打印-----------
    skipPrin_manual () {
      this.$router.push(
        {
          name: 'Invoice',
          query: {
            manual: 1
          }
        }
      )
    },
    // -------------外部点击显示附加费-----------
    showAdditional_external () {
      this.isID = true
      this.additionalShow = true
    },
    // -------------显示附加费-----------
    showAdditional () {
      this.isID = false
      this.additionalShow = true
    },
    // -------------返回上一页-----------
    returnPage () {
      this.$router.go(0)
    },
    // -------------点击打印-----------
    clickPrint () {
      this.$prompt('请输入物流单号', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(({ value }) => {
        this.skipPrint(value)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        });
      });
    },
    // -------------跳转打印发票-----------
    async skipPrint (wlnum) {
      let res = await apiAppAdditional({
        op: 'outck',
        pd: "orderinfo",
        wlnum,
      })
      if (res.errno == 0) {
        this.$router.push(
          {
            name: 'Invoice',
            query: {
              id: res.orderid
            }
          }
        )

      } else {
        this.$message.error(res.message)
      }
    },
    // -------------添加附加费-----------
    async addAdditional () {
      let res = await apiAppAdditional({
        op: 'otherprice',
        wlnum: this.isID ? this.additionalWlnum : '',
        orderid: !this.isID ? this.isData.order.id : '',
        pd: 'ok',
        otherprice: this.additionalPrice,
        otherpriceinfo: this.additionalInfo
      })

      if (res.errno == 1) {
        return this.$message.error(res.message)
      } else {
        this.$message.success(res.message)
        this.additionalWlnum = '';
        this.additionalPrice = '';
        this.additionalInfo = '';
      }

      this.additionalShow = false
    },
    // -------------出库数据检查-----------
    ck_data_examine () {
      let falg = true
      for (const key in this.ck_data) {
        if (this.ck_data[key] == '') {
          if (key == 'remark' && this.ck_data.driverid == '0') {
            return falg = false
          } else if (key == 'driverid') {
            return falg = false
          }
        }
      }
      return falg
    },
    // -------------出库提示-----------
    ck_message () {
      if (this.ck_data_examine()) {
        this.$confirm(`确定要出库${this.kdnum}的订单吗?请确定已经打印了票单.`, '确定出库', {
          confirmButtonText: '出 库',
          cancelButtonText: '取 消',
          type: 'warning',
        }).then(() => {
          this.deliveryCargoStorage()
        }).catch(() => {

        });
      } else {
        this.$message.error('请选择出库司机')
      }

    },
    // -------------出库-----------
    async deliveryCargoStorage () {
      this.fullscreenLoading = true
      let res = await apiDeliveryCargoStorage({
        op: 'outck',
        pd: 'okout',
        wlnum: this.kdnum,
        bak: this.ck_data.driverid === '0' || this.ck_data.driverid === 0 ? this.ck_data.remark : '',
        orderid: this.isData.order.id,
        sjuid: this.ck_data.driverid
      })
      common.returnData(this, res.errno, res.message, () => {
      })
      if (res.errno == 0) {
        setTimeout(() => {
          location.reload();
          this.fullscreenLoading = false
        }, 2000);
      }
    },
    // -------------切换清除数据-----------
    tab_eliminate_data () {
      this.isData = ''
    },
    // -------------获取出库数据-----------
    async getOrderDataCK (code, fun) {
      this.fullscreenLoading = true
      let res = await apiDeliveryStorage({
        pd: 'orderinfo',
        op: 'outck',
        wlnum: code,
      })
      this.fullscreenLoading = false
      this.ckDitchList = res.qdlist
      this.ckDitch = res.order.cid
      return fun ? fun(res) : res
    },
    // -------------获取订单转化数据-----------
    async getOrderData (code, fun) {
      this.fullscreenLoading = true
      let res = await apiNewBePutInStorage({
        pd: 'kdtooid',
        wlnum: this.goOut ? '' : code,
        kdnum: this.goOut ? code : ''
      })
      this.fullscreenLoading = false
      return fun ? fun(res) : res
    },
    // -------------获取司机列表-----------
    async getDriver (id) {
      this.fullscreenLoading = true
      let res = await apiOrderDetails({
        op: 'orderinfo',
        orderid: id,
        pd: 'getorderotherinfo',
        getsjlist: 1
      })
      this.driver = common.transformValue(res.driver)
      this.fullscreenLoading = false
    },
    // -------------出库数据处理-----------
    async ck_dispose (code) {
      this.fullscreenLoading = true
      let res = ''
      if (this.goOut) {
        res = await this.getOrderData(code)
      } else {
        res = await this.getOrderDataCK(code)
      }
      if (res.errno == 1) {
        this.fullscreenLoading = false
        return this.$message.error('未找到' + code + '单号的订单,请检查')
      }
      this.kdnum = code
      this.isData = ''
      this.rk_data.wpinfo = []
      this.rk_data.zxd = []
      this.isData = res
      this.getDriver(res.order.id)
      this.fullscreenLoading = false
    },
    // -------------认领单数据判断-----------
    claim_order_full () {
      if (this.detection_Data_null(this.claimData.claim_zxd)) {
        this.setClaim()
      } else {
        this.$message.error('请检查装箱单信息是否填写完整')
      }

    },
    // -------------添加新的装箱单-----------
    handleAdd (index, rows, row) {
      let data = {
      }
      rows.push(data)
    },
    // -------------删除某一个装箱单-----------
    handleDelete (index, rows, row) {
      rows.splice(index, 1);
    },
    // -------------进入添加认领单-----------
    in_add_claim () {
      this.claimData.claim_number = this.kdnum
      this.rl_dialog = true
    },
    // -------------进入打印界面-----------
    skip_print_view () {
      this.fullscreenLoading = true;
      this.$router.push(
        {
          name: 'Invoice',
          query: {
            id: this.isData.order.id
          }
        }
      )
      this.fullscreenLoading = false;
    },
    // -------------弹出输入快递单号-----------
    bounce (fun) {
      this.$prompt('请输入快递单号', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(({ value }) => {
        fun(value)
      }).catch(() => {

      });
    },
    // -------------手动出库-----------
    manual_ck (fun) {
      console.log(12);
      this.$prompt('请输入物流号/订单ID', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(({ value }) => {
        fun(value)
      }).catch(() => {

      });
    },
    // -------------手动填写-----------
    manualOperation () {
      let fun;
      if (this.goOut) {
        this.bounce((value) => {
          this.readingData(value)
        })
      } else {
        this.manual_ck((value) => {
          this.ck_dispose(value)
        })
      }
    },
    // -------------提交认领-----------
    async setClaim () {

      this.fullscreenLoading = true
      let res = await apiNewBePutInStorage({
        pd: 'okruku',
        renorder: 1,
        kdnum: this.claimData.claim_number,
        kdname: this.claimData.claim_kdname,
        zxdinfo: JSON.stringify(this.rk_data.zxd),
      })
      common.returnData(this, res.errno, res.message, () => {
        setTimeout(() => {
          this.$router.go(0)
        }, 1200)
      })
      this.fullscreenLoading = false

      // qwe123123a
    },
    // -------------提交入库-----------
    async setBePutInStorage () {
      this.fullscreenLoading = true

      let res = await apiNewBePutInStorage({
        pd: 'okruku',
        orderid: this.isData.order.id,
        kdname: this.isData.order.type == 2 ? '' : this.rk_data.kdname,
        zxdinfo: JSON.stringify(this.rk_data.zxd),
        // wp: JSON.stringify({ wpinfo: wpinfo })
      })
      this.fullscreenLoading = false

      common.returnData(this, res.errno, res.message, () => {
        this.fullscreenLoading = false
        if (res.errno == 1) {
          setTimeout(() => {
            this.$router.go(0)
          }, 1000);
        }
        if (this.isData.order.type == 1) {
          this.otherOperation = true
        } else {
          setTimeout(() => {
            this.$router.go(0)
          }, 1000);
        }
      })
    },
    // -------------检测物品info是否为空----------
    detection_wpinfo_null (data) {
      let falg = true

      return falg
    },
    // -------------检测数据是否为空-----------
    detection_Data_null (data) {
      let falg = true

      return falg
    },
    // -------------确定提交入库数据-----------
    confirm_rk () {
      if (this.isData.order.type == 2) {
        return this.setBePutInStorage()
      }

      if (this.detection_Data_null(this.rk_data.zxd)) {
        if (this.detection_wpinfo_null(this.rk_data.wpinfo)) {
          this.setBePutInStorage()
        } else {
          return this.$message.error('请确认物品数据是否填写完全')

        }
      } else {
        return this.$message.error('请确认装箱单数据是否填写完全')

      }

    },
    // -------------入库数据处理-----------
    rk_dispose (code) {
      this.kdnum = ''
      this.isData = ''
      this.rk_data.wpinfo = []
      this.rk_data.zxd = []
      this.readingData(code)
    },
    // -------------获取数据-----------
    async readingData (code) {
      this.fullscreenLoading = true
      let res = await this.getOrderData(code)
      if (res.errno == 0) {
        this.get_order_data_null = false
        this.isData = res
        this.goodsInfo = res.wptype
        this.rk_data.zxd = res.zxdinfo
        for (const key in this.rk_data.zxd) {
          this.rk_data.zxd[key].chang = ''
          this.rk_data.zxd[key].kuan = ''
          this.rk_data.zxd[key].gao = ''
          this.rk_data.zxd[key].weight = ''
        }

      } else {
        this.get_order_data_null = true
      }
      this.kdnum = code
      this.goodsInfo = common.transform(res.wptype)
      this.allKD100 = res.kd100
      this.fullscreenLoading = false
    }
  },
  created () {
    this.currenctyDate = common.transformValue(this.currenctyDate)
    //页面加载完执行事件
    var code = "";
    var lastTime, nextTime;
    var lastCode, nextCode;
    //用户按下按键执行
    document.onkeydown = (e) => {
      if (this.start_scan) {
        // 保存按键码
        nextCode = e.which;

        // 设置跳过的特殊字段
        if (nextCode == 16) {
          return
        }

        //保存按键时间
        nextTime = new Date().getTime();
        // 如果按键码不为空 且 上一次按键码也不为空 且 两次按键激活时间小等于30毫秒 
        if (lastCode != null && lastTime != null && nextTime - lastTime <= 30) {
          // code值加上当前按下的值并保存
          code += lastCode;
          // 如果两次按键激活时间大于100毫秒
        } else if (lastCode != null && lastTime != null && nextTime - lastTime > 100) {
          // 清除code值
          code = "";
        }
        // 保存这次按键码
        lastCode = e.key;
        // 保存这次按键时间
        lastTime = nextTime;
        //如果用户按下回车
        if (e.which == 13) {
          // 如果当前保存的值大于2位
          if (code.length < 2) {
            //手动输入的时间不会让code的长度大于2，所以这里只会对扫码枪有效
            //返回false
            return false;
          }
          this.kdnum = code //要更改的值变成扫码枪的值 this.queryCondition.kdnum可以改成需要更改的值
          if (this.goOut) {
            this.rk_dispose(code)//入库处理
          } else {
            this.ck_dispose(code)
          }
          code = ""; //清空值
        }
      }

    }
  }
}
</script>

<style lang='scss'>
.ComeInAndGoOut {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  .zxdInfo {
    width: 100%;
  }
  .item_view {
    display: flex;
    margin-top: 40px;
    justify-content: space-between;
    .view_list {
      display: flex;
      width: 45%;
      span {
        width: 50px;
      }
    }
  }
  .addClaimOrder {
    min-width: 1100px;
    .el-dialog__title {
      box-shadow: -2px 9px 0px -4px #409eff;
    }
    .el-form {
      margin-left: 50px;
      .el-form-item {
        margin-bottom: 50px;
      }
      .el-form-item__label {
        text-align: left;
        font-size: 16px;
        padding-left: 10px;
        box-shadow: -14px 0 0px -10px #409eff;
      }
      .claimData_input {
        width: 150px;
        input {
          border-radius: 0;
          border: 0;
          border-bottom: 1px solid #ccc;
        }
        input:focus {
          border-bottom: 1px solid #409eff;
        }
      }
    }
  }
  .chuku_btn {
    .el-radio__inner:hover {
      border-color: #67c23a;
    }
  }
  .comeInAndGoOut_top {
    width: 100%;
    height: 100px;
    position: relative;
    display: flex;
    justify-content: center;
    background-color: #fff;
    .delivery_carg_ostorage {
      background-color: #67c23a !important;
      box-shadow: 0 0 4px 1px #67c23a !important;
      .el-radio__inner {
        border-color: #67c23a;
        background-color: #aad694 !important;
      }
    }

    .manual_operation {
      width: 100%;
      height: 30px;
      color: #fff;
      position: absolute;
      right: 10px;
      bottom: -90px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      border-radius: 10px;
      transition: all 0.5s;
      cursor: pointer;
      // font-weight: 700;
    }

    .comeInAndGoOut_top_btn {
      width: 50%;
      height: 100%;
      display: flex;
      justify-content: space-around;
      align-items: center;
      .el-radio {
        width: 200px;
        height: 50px;
        padding: 0;
        display: flex;
        background-color: rgb(201, 201, 201);
        align-items: center;
        transition: all 0.3s;
        box-shadow: 0 0 4px 1px rgb(201, 201, 201);
        border: 0;
        .el-radio__inner {
          width: 20px;
          margin-left: 10px;
          height: 20px;
          transition: all 0.3s;
        }
        .el-radio__label {
          font-size: 20px;
          font-weight: 700;
          color: #fff;
        }
        .el-radio__input {
          background-color: transparent;
        }
      }
      .el-radio.is-bordered.is-checked {
        background-color: #409eff;
        box-shadow: 0 0 4px 1px #409eff;
        .el-radio__inner {
          background-color: #7bb9f8;
        }

        .el-radio__label {
          // color: #;
        }
      }
    }
  }
  .comeInAndGoOut_mian {
    position: relative;
    width: 100%;
    overflow-y: auto;
    min-height: 600px;
    height: 70%;
    margin-top: 100px;
    background-color: #fff;
    .dataNull {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      .dataNull_main {
        min-width: 500px;
        min-height: 500px;
        width: 50%;
        height: 50%;
        background-color: #fff;
        background: url("/assets/images/data_null.png") no-repeat;
        background-size: 500px 500px;
        background-position: center;
      }
      span {
        color: #89909b;
      }
    }
    .orderNumberNull {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .orderNumberNull_img {
        width: 300px;
        height: 300px;
        background: url("/assets/images/order_null.png");
        background-color: #fff;
      }
      .scan_a_QR_code_img {
        width: 300px;
        height: 300px;
        background: url("/assets/images/scan_a_QR_code.png") no-repeat;
        background-size: 100%;
        background-color: #409eff;
        box-shadow: 0 0 5px 1px #409eff;
        border-radius: 10px;
        transition: all 0.3s;
      }
      .scan_a_QR_code_title {
        color: #fff;
        background-color: #409eff;
        width: 300px;
        height: 50px;
        display: flex;
        border-radius: 10px;
        align-items: center;
        box-shadow: 0 0 5px 1px #409eff;
        justify-content: center;
        font-size: 20px;
        letter-spacing: 2px;
        margin-top: 50px;
        transition: all 0.3s;
      }
      .ck_bg {
        background-color: #67c23a;
        box-shadow: 0 0 5px 1px #67c23a;
      }
      .orderNumberNull_title {
        color: #919294;
      }
      .orderNumberNull_operation {
        width: 100%;
        height: 100px;
        margin-top: 20px;
        display: flex;
        justify-content: space-evenly;
        align-items: center;
        .el-button {
          font-size: 12px;
          width: 100px;
          height: 40px;
          border-radius: 15px;
          box-shadow: 0 0 5px 1px #409eff;
        }
      }
    }
    .delivery_cargo_storage_main,
    .be_put_storage_main {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .delivery_cargo_storage_top,
      .be_put_storage_top {
        width: 100%;
        min-height: 100px;
        // background-color: pink;
        font-size: 24px;
        color: #333;
        display: flex;
        justify-content: center;
        align-items: center;
        letter-spacing: 5px;
        span {
          box-shadow: -9px 17px 0px -10px #409eff;
          .orderType {
            font-size: 16px;
          }
        }
      }
      .delivery_cargo_storage_top {
        span {
          box-shadow: -9px 17px 0px -10px #67c23a;
        }
      }
      .delivery_cargo_storage_content,
      .be_put_storage_content {
        width: 90%;
        height: 80%;
        position: relative;
        min-height: 700px;
        // width: 100%;

        .select_ck {
          input {
            border: 0;
            border: 1px solid #ccc;
          }
          input:focus {
            border-color: #67c23a;
            // outline: 1px solid #67c23a;
          }
        }
        .el-table {
          margin-bottom: 10px;
          padding-bottom: 10px;
          .el-input__inner:hover {
            border-color: #409eff;
          }
        }
        .el-table::before {
          width: 0;
        }
        .el-form {
          .el-form-item {
            border-bottom: 1px solid #eee;
            .expand_btn {
              margin: 10px 0;
            }
            .el-tooltip__popper {
              transition: none;
            }
          }
          .skipPrintBtn {
            height: 40px;
          }
          .el-form-item__content {
            min-height: 60px;
            display: flex;
            .query {
              display: flex;
              justify-content: center;
              align-content: center;
              margin-left: 10px;
              width: 40px;
              font-size: 18px;
              cursor: pointer;
              color: #409eff;
              height: 40px;
              // background-color: pink;
            }
            .kdnumber {
              .el-tag {
                font-size: 16px;
                letter-spacing: 1px;
              }
            }
          }
          .el-form-item__label {
            box-shadow: -17px 0px 0px -10px #409eff;
            text-align: left;
            font-size: 16px;
            padding-left: 10px;
          }
        }
        .confirm_request {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 70px;
          height: 70px;
          position: fixed;
          right: 100px;
          bottom: 10%;
          border-radius: 50%;
          box-shadow: 0 0 5px 1px #409eff;
          background-color: #409eff;
          color: #fff;
          transition: all 0.3s;
          font-size: 20px;
          cursor: pointer;
        }
        .confirm_request:hover {
          background-color: #3c79b6;
        }
      }
      .delivery_cargo_storage_content {
        .el-form-item__label {
          box-shadow: -17px 0px 0px -10px#67c23a !important;
        }
        .request_ck {
          box-shadow: 0 0 5px 1px #67c23a;
          background-color: #67c23a;
        }
        .request_ck:hover {
          background-color: #a1d388;
          box-shadow: 0 0 10px 1px #a1d388;
        }
      }
    }
  }
}
</style> 